module.exports = __webpack_public_path__ + "img/banner.c43381f0.png";